export default [
  {
    name: 'callBellRecord',
    path: '/callBellRecord',
    component: () => import('@/views/callBell/cbRecord/Index'),
    meta: {
      keepAlive: true,
    },
  },
  {
    name: 'callBellEnvironment',
    path: '/callBellEnvironment',
    component: () => import('@/views/callBell/cbEnvironment/Index'),
    meta: {
      keepAlive: true,
    },
  },
  {
    name: 'callBellEnvironment_add',
    path: '/callBellEnvironment/add',
    component: () => import('@/views/callBell/cbEnvironment/Add')
  },
  {
    name: 'callBellEnvironment_edit',
    path: '/callBellEnvironment/edit/:mac/:env/:name',
    component: () => import('@/views/callBell/cbEnvironment/Edit')
  },
  {
    name: 'callBellFacility',
    path: '/callBellFacility',
    component: () => import('@/views/callBell/cbFacility/Index'),
    meta: {
      keepAlive: true,
    },
  },
  {
    name: 'callBellFacility_edit',
    path: '/callBellFacility/edit/:id',
    component: () => import('@/views/callBell/cbFacility/Edit')
  },
  {
    name: 'callBellNfcManagement',
    path: '/callBellNfcManagement',
    component: () => import('@/views/callBell/cbNfcManagement/Index'),
    meta: {
      keepAlive: true,
    },
  },
  {
    name: 'callBellReport',
    path: '/callBellReport',
    component: () => import('@/views/callBell/cbReport/Index'),
    meta: {
      keepAlive: true,
    },
  },
  {
    name: 'callBellRawDown',
    path: '/callBellRawDown',
    component: () => import('@/views/callBell/cbRawDown/Index'),
    meta: {
      keepAlive: true,
    },
  },
  {
    name: 'callBellRawTech',
    path: '/callBellRawTech',
    component: () => import('@/views/callBell/cbRawTech/Index'),
    meta: {
      keepAlive: true,
    },
  },
  {
    name: 'callBellBatchUpload',
    path: '/callBellBatchUpload',
    component: () => import('@/views/callBell/cbBatchUpload/Index')
  },
  {
    name: 'callBellPatrolRecord',
    path: '/callBellPatrolRecord',
    component: () => import('@/views/callBell/cbPatrolRecord/Index'),
    meta: {
      keepAlive: true,
    },
  },
  {
    name: 'callBellPatrolReport',
    path: '/callBellPatrolReport',
    component: () => import('@/views/callBell/cbPatrolReport/Index'),
    meta: {
      keepAlive: true,
    },
  },
  {
    name: 'callBellBattery',
    path: '/callBellBattery',
    component: () => import('@/views/callBell/cbBattery/Index'),
    meta: {
      keepAlive: true,
    },
  },
  // {
  //   name: 'callBellPatrolRawDown',
  //   path: '/callBellPatrolRawDown',
  //   component: () => import('@/views/callBell/callBellPatrolRawDown/Index')
  // },
]
